import { createContext, useContext } from 'react';
export const DataLayerParametersContext = createContext({});
export function useDataLayer() {
    const contextParameters = useContext(DataLayerParametersContext);
    const push = (parameters) => window?.dataLayer?.push({
        ...contextParameters,
        ...parameters,
    });
    return { push, contextParameters };
}
